export const GrowthbookFakeExperimentExperiment = {
  TEST_ID: 'oHUXOZBgQHy7KCSh97Wjbg',
  name: 'GrowthBook Fake Experiment',
};
export const FeedbackAwarenessCtaExperiment = {
  TEST_ID: '8d3bcb79c46428d165b23333ab9ebe39565579a98c4656d1b4c666a005836735',
  name: 'AB Test - "Refine your formula" vs "Provide feedback"',
};
export const SkincareConcernsOrderExperiment = {
  TEST_ID: 'b471cae68150ccf2c376b36318ee95365d36e2ca5c3c2d66f0b1c01dc9886b8b',
  name: 'skincare-concerns-order',
};
export const SubscriptionItemRemovalExperiment = {
  TEST_ID: 'b7e91d330fbea0e29ad20d754fd7de52e398fadf9797b7ea875ec8afb29946f6',
  name: 'Subscription Item Removal',
};
export const KeyActionCardExperiment = {
  TEST_ID: 'b2fd43fd11cfd9fe89252b313699dee10e825bed57a0142cc7e1705020440ac5',
  name: 'account_overview_key_action_card_ab_test_april_2025',
};
export const FrequencyUpdateClarificationExperiment = {
  TEST_ID: '6c9b89c27503721902a6a37f459a5c31190f2d6e6e12f5f38cf17e62a60642a5',
  name: 'Frequency Update Clarification AB Test',
};
export const CheckoutCtaExperiment = {
  TEST_ID: 'd66bc81fa72fc96e3cbc8c8b4d0df9eedd58ee9bfc4c52e0a5c87d14a9965414',
  name: 'Checkout CTA',
};
export const ConsultationEntryModuleExperiment = {
  TEST_ID: 'ea57476916ca0be465b4129fea4aa32b556ade833c3ac86d5a0e513f3e0d577c',
  name: 'homepage_embedded_name',
};
export const PostPurchaseInterstitialSssExperiment = {
  TEST_ID: '835fae7a04793ae0071988b45c7ee7522b5c5bcaafeab423c2cfb49551e28f96',
  name: 'post-purchase-interstitial-sss-ab-test',
};
export const KeyActionCardsOnTopExperiment = {
  TEST_ID: '68eb865feab44829f3032d6049917900b5f763ad07e0f29783c07ebe299c8aab',
  name: 'just_in_just_for_you_card_placements',
};
